// extracted by mini-css-extract-plugin
module.exports = {"specification":"Specification_specification__2FQiX","specificationList":"Specification_specificationList__2nBsB","specificationItem":"Specification_specificationItem__2YQPD"};